import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { Crown, LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { UploadPregnancyPhotoDialog } from "../UploadPregnancyPhotoDialog";
import { GalleryPdfExport } from "../GalleryPdfExport";
import { GalleryPhoto } from "../carousel/types";

interface PregnancyPhotoHeaderProps {
  selectedWeek: string | null;
  isPremium?: boolean;
  isGuestMode?: boolean;
  userId?: string;
  onPhotoUploaded: () => void;
  weeklyPhotos: GalleryPhoto[];
}

export function PregnancyPhotoHeader({
  selectedWeek,
  isPremium = false,
  isGuestMode = false,
  userId,
  onPhotoUploaded,
  weeklyPhotos
}: PregnancyPhotoHeaderProps) {
  const { language } = useLanguage();

  if (!selectedWeek) return null;

  return (
    <div className="flex justify-between items-center mb-3">
      <h3 className="text-lg font-medium">
        {t('generate.photosFrom', language)} {selectedWeek}
      </h3>
      <div className="flex gap-2">
        {/* Only show upload button for premium users */}
        {!isGuestMode && isPremium && userId && (
          <UploadPregnancyPhotoDialog 
            userId={userId}
            week={selectedWeek}
            onPhotoUploaded={onPhotoUploaded}
          />
        )}
        {!isGuestMode && !isPremium && (
          <Link to="/premium">
            <Button size="sm" variant="outline" className="flex items-center gap-1">
              <Crown className="h-3 w-3 text-amber-500" />
              {t('premium.upgrade', language) || 'Upgrade'}
            </Button>
          </Link>
        )}
        {isGuestMode && (
          <Link to="/login">
            <Button size="sm" variant="outline" className="flex items-center gap-1">
              <LogIn className="h-3 w-3" />
              {t('common.login', language)}
            </Button>
          </Link>
        )}
        {!isGuestMode && weeklyPhotos.length > 0 && (
          <GalleryPdfExport 
            photos={weeklyPhotos} 
            collectionTitle={`${t('generate.pregnancyJourney', language)} ${selectedWeek}`}
          />
        )}
      </div>
    </div>
  );
}
